module.exports = __webpack_public_path__ + "static/media/icon_quanmianfanghu.4c5752be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/icon_quanmianfanghu.svg
// module id = 226
// module chunks = 0